// 响应式图文介绍区块 Web Component
class FeatureSection extends HTMLElement {
	constructor() {
		super();
		this.data = {};
	}

	static get observedAttributes() {
		return ['data'];
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (name === 'data' && newValue !== oldValue) {
			try {
				// 解码 URL 编码的数据
				const decodedData = decodeURIComponent(newValue);
				this.data = JSON.parse(decodedData);
				this.render();
			} catch (error) {
				console.error('Invalid JSON data:', error);
			}
		}
	}

	connectedCallback() {
		// 获取初始数据
		const dataAttr = this.getAttribute('data');
		if (dataAttr) {
			try {
				// 解码 URL 编码的数据
				const decodedData = decodeURIComponent(dataAttr);
				this.data = JSON.parse(decodedData);
			} catch (error) {
				console.error('Invalid JSON data:', error);
				this.data = {};
			}
		}
		this.render();
		this.setupResponsiveHandlers();
	}

	setupResponsiveHandlers() {
		// 监听窗口大小变化，优化响应式布局
		const handleResize = () => {
			this.updateLayout();
		};

		window.addEventListener('resize', handleResize);

		// 组件销毁时清理事件监听器
		this.addEventListener('disconnected', () => {
			window.removeEventListener('resize', handleResize);
		});
	}

	updateLayout() {
		const container = this.querySelector('.feature-container');
		if (container) {
			// 根据屏幕尺寸动态调整布局
			if (window.innerWidth < 768) {
				container.classList.remove('lg:grid-cols-2');
				container.classList.add('grid-cols-1');
			} else {
				container.classList.remove('grid-cols-1');
				container.classList.add('lg:grid-cols-2');
			}
		}
	}

	render() {
		const {
			title = '',
			tag = '',
			description = '',
			image = '',
			imagePosition = 'right',
			textAlignment = 'left'
		} = this.data;

		console.log('chaxi', tag);

		// 根据图片位置决定布局
		const isImageLeft = imagePosition === 'left';
		const textOrder = isImageLeft ? 'order-2 lg:order-2' : 'order-1 lg:order-1';
		const imageOrder = isImageLeft
			? 'order-1 lg:order-1'
			: 'order-2 lg:order-2';

		// 文本对齐样式
		const textAlignClass =
			textAlignment === 'center'
				? 'text-center items-center'
				: textAlignment === 'right'
				? 'text-right items-end'
				: 'text-left items-start';

		this.innerHTML = `
      <section class="w-full rounded-2xl overflow-hidden">
        <div class="feature-container grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 p-8 lg:p-12 min-h-[400px] lg:min-h-[500px]">
          <!-- 文本内容区域 -->
          <div class="flex flex-col justify-center space-y-6 ${textOrder} ${textAlignClass}">
            <!-- 标签和标题组 -->
            <div class="flex flex-col lg:flex-col gap-3">
              <!-- 桌面端：标签在上方 -->
              ${
								tag
									? `
                <div class="hidden lg:block">
                  <div class="relative bg-gradient-to-r from-violet-500 to-cyan-500 rounded-full transition-all duration-200 ease-in-out hover:scale-105 w-fit">
                    <div class="absolute inset-[2px] bg-gray-950 rounded-full z-10"> </div>
                    <div class="relative z-20 rounded-full">
                      <span class="bg-gradient-to-r px-4 py-1 from-violet-500 to-cyan-500 bg-clip-text text-transparent text-lg font-bold tracking-wide uppercase">
                        ${tag}
                      </span>
                    </div>
                  </div>
                </div>
              `
									: ''
							}

              <!-- 移动端：标签和标题在同一行 -->
              <div class="flex flex-row lg:flex-col items-center lg:items-start gap-3 lg:gap-0">
                <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
                  ${title}
                </h2>
                ${
									tag
										? `
                  <div class="lg:hidden">
                    <div class="relative bg-gradient-to-r from-violet-500 to-cyan-500 rounded-full transition-all duration-200 ease-in-out">
                      <div class="absolute inset-[2px] bg-gray-950 rounded-full z-10"> </div>
                      <div class="relative z-20 rounded-full">
                        <span class="bg-gradient-to-r px-4 py-1 from-violet-500 to-cyan-500 bg-clip-text text-transparent text-lg font-bold tracking-wide uppercase min-w-[70px] flex">
                          ${tag}
                        </span>
                      </div>
                    </div>
                  </div>
                `
										: ''
								}
              </div>
            </div>

            <!-- 描述文字 -->
            <p class="text-white text-2xl sm:text-2xl lg:text-2xl leading-relaxed max-w-2xl">
              ${description}
            </p>
          </div>

          <!-- 图片区域 -->
          <div class="flex items-center justify-center lg:justify-${
						isImageLeft ? 'start' : 'end'
					} ${imageOrder}">
            <div class="w-full max-w-md lg:max-w-lg xl:max-w-xl">
              ${
								image
									? `
                <img
                  src="${image}"
                  alt="${title}"
                  class="w-full h-auto rounded-xl shadow-2xl object-cover aspect-[4/3] lg:aspect-[3/2]"
                  loading="lazy"
                  onerror="this.style.display='none'"
                />
              `
									: `
                <div class="w-full aspect-[4/3] lg:aspect-[3/2] bg-gray-200 rounded-xl flex items-center justify-center">
                  <span class="text-white text-lg">暂无图片</span>
                </div>
              `
							}
            </div>
          </div>
        </div>
      </section>
    `;

		// 初始化布局
		this.updateLayout();
	}

	// 公共方法：更新组件数据
	updateData(newData) {
		this.data = {...this.data, ...newData};
		this.setAttribute('data', encodeURIComponent(JSON.stringify(this.data)));
	}

	// 公共方法：获取组件数据
	getData() {
		return {...this.data};
	}
}

// 注册 Web Component
customElements.define('feature-section', FeatureSection);

// 导出组件类（如果需要在其他地方使用）
window.FeatureSection = FeatureSection;
